import { createFileRoute } from '@tanstack/react-router';
import { PersonalDataLayout } from '@/features/account/profile/personal-data/shared';
import { IdentityRouteGuard } from '@/features/account/identity-confirmation';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/dados-pessoais')({
  // DEV-555 (AC-11) — editar dados pessoais/contato/diversidade pede confirmação de identidade.
  component: () => (
    <IdentityRouteGuard target="personal-data">
      <PersonalDataLayout />
    </IdentityRouteGuard>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
